import { FC } from 'react'
import { CircularProgress, LinearProgress } from '../../../'
import { LoaderProps, LOADER_TYPES } from './types'

const Loader: FC<LoaderProps> = ({ type = LOADER_TYPES.CIRCULAR, color }) => {
  switch (type) {
    case LOADER_TYPES.LINEAR:
      return <LinearProgress />
    default:
      return (
        <CircularProgress
          style={{
            display: 'block',
            margin: '30px auto',
            color: color || 'var(--bosscat-blue-600)',
          }}
        />
      )
  }
}

export default Loader
